import {
    Box,
    Card,
    Icon,
    IconButton,
    LinearProgress,
    Skeleton,
    styled,
    MuiTable as Table,
    MuiTableCell as TableCell,
    MuiTableRow as TableRow,
    Typography,
} from '../../../base';

import { tableCellClasses, linearProgressClasses } from '@mui/material';

export const StyledWrapperCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2),
    height: '100%',
    // Adjust maxHeight or height as needed
    maxHeight: '260px',
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.borderRadius,
}));

export const StyledCardHeader = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 0,
    marginBottom: theme.spacing(0.5),
}));

export const StyledHeaderContent = styled(Box)(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
}));

// Icon wrapper style - Copied from DashboardAlerts
export const StyledIconWrapper = styled(IconButton)(({ theme }) => ({
    marginInlineEnd: theme.spacing(1),
    height: '55px',
    width: '55px',
    '&:disabled': {
        backgroundColor: theme.palette.background.mainBackground,
    },
}));

// Icon style - Copied from DashboardAlerts (adjust color if needed)
export const StyledHeaderIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.secondary.main, // Changed to primary color
}));

// Optional: Style for the action icon on the right (if needed)
export const StyledActionIcon = styled(Icon)(({ theme }) => ({
    color: theme.palette.primary.main, // Example color
}));

export const StyledSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.spacing(1),
}));

// --- Table Styles ---

export const StyledTable = styled(Table)(() => ({
    borderCollapse: 'separate',
}));

export const StyledHeaderRow = styled(TableRow)(({ theme }) => ({
    '& > .MuiTableCell-root': {
        padding: `${theme.spacing(0.125)} ${theme.spacing(0.75)} !important`,
        borderBottom: `1px solid ${theme.palette.divider}`,
        fontWeight: 500,
        lineHeight: '1 !important',
        backgroundImage: 'none',
    },
}));

export const StyledTableRow = styled(TableRow)(() => ({
    [`& .${tableCellClasses.root}`]: {
        borderBottom: 'none', // Remove default cell border
        padding: '4px 8px', // Adjust cell padding
        verticalAlign: 'middle',
    },
}));

export const StyledLinkCell = styled(TableCell)(() => ({
    width: '150px',
    textAlign: 'start',
    padding: '4px 12px 4px 8px !important', // More right padding for gap
}));

export const StyledNumbersCell = styled(TableCell)(() => ({
    width: '1%', // Minimal width, just fit content
    whiteSpace: 'nowrap',
    textAlign: 'start',
    padding: '4px 4px !important', // Tight padding between 2nd/3rd columns
}));

export const StyledRankCell = styled(TableCell)(() => ({
    width: '30px',
    textAlign: 'start',
    padding: '4px 8px !important',
}));

export const StyledProgressCell = styled(TableCell)(() => ({
    width: 'auto', // Let it take remaining space
    textAlign: 'start',
    padding: '4px 8px 4px 4px !important', // Tight left padding close to 3rd column
}));

export const StyledProgressBarContainer = styled(Box)(() => ({
    display: 'flex',
    width: 'auto',
    alignItems: 'center',
    gap: '8px',
}));

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
    flexGrow: 1,
    height: 8,
    borderRadius: 4,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[300], // Background of the progress bar track
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 4,
        backgroundColor: theme.palette.primary.main, // Color of the progress bar itself
    },
}));

export const StyledPercentageLabel = styled(Typography)(({ theme }) => ({
    minWidth: '50px', // Ensure space for "XXX%"
    textAlign: 'center',
    fontSize: '0.8rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: theme.shape.borderRadius,
    padding: '2px 6px',
}));

// --- Empty State Styles (Optional, like in DashboardAlerts) ---
export const StyledEmptyStateBox = styled(Box)(({ theme }) => ({
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    gap: theme.spacing(1),
    color: theme.palette.text.secondary,
}));
